import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'showAdminTab';
export const ADMIN_TAB_VISIBILITY_EVENT = 'adminTabVisibilityChanged';

/**
 * Whether admin-only features are shown in the navigation. Persisted in
 * localStorage and broadcast on {@link ADMIN_TAB_VISIBILITY_EVENT} so the shell
 * navigation can react without a reload.
 */
export const useAdminTabVisibility = () => {
  const [showAdminTab, setShowAdminTab] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      setShowAdminTab(stored === 'true');
    }
  }, []);

  const setVisibility = useCallback((visible: boolean) => {
    setShowAdminTab(visible);
    localStorage.setItem(STORAGE_KEY, visible.toString());
    window.dispatchEvent(
      new CustomEvent(ADMIN_TAB_VISIBILITY_EVENT, { detail: { visible } }),
    );
  }, []);

  return { showAdminTab, setVisibility };
};
